CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Board = require 'app/scripts/models/board'

class PublicBoardList extends CollectionWithHelpers
  model: Board

module.exports = PublicBoardList
